export const CORE_EXCHANGE_DOCS_BASE_URL = '/core-exchange/docs';

// Latest API version for search filtering - update this when a new version is released
export const LATEST_API_VERSION = '6.4';
